import createStoreWithMiddleware from 'utils/store/createStoreWithMiddleware'

const connectMeStore = createStoreWithMiddleware()

window.connectMeStore = connectMeStore

export default connectMeStore
